// extracted by mini-css-extract-plugin
export var actionText = "_jp-4";
export var container = "_jp-0";
export var leftSection = "_jp-1";
export var rightSection = "_jp-2";
export var settingsButton = "_jp-6";
export var settingsIcon = "_jp-7";
export var shortcut = "_jp-5";
export var shortcutGroup = "_jp-3";